var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-dark btn-sm btn-logoff",attrs:{"type":"button","id":"btn-logoff"},on:{"click":_vm.logOff}},[_c('b-icon',{attrs:{"icon":"power","aria-hidden":"true"}}),_vm._v(" Uitloggen ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }